import React from 'react';

export default function ExternalLinkIcon(): JSX.Element {
  return <i className={'zmdi zmdi-open-in-new external-link-icon'} />;
}
